import { useAuth0 } from '@auth0/auth0-react';

const useAuthentication = useAuth0;

export default useAuthentication;
